export enum SubscriptionPlanPriceFrequency {
    Monthly = "Monthly",
    Annually = "Annually"
}